export function organisationPath(path: string): string {
  return `/$organisation${path}`
}
